// extracted by mini-css-extract-plugin
export default {"container":"Style_container__tmAYU","preview":"Style_preview__Mx+Dd","title":"Style_title__JCNl1","image":"Style_image__7FniY","property":"Style_property__3uzvg"};